(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["abrazofit-countdown"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var KEY = 'abrazofit-cd-end';
    function pad(n) { return n < 10 ? '0' + n : '' + n; }

    function init(root) {
      if (root.getAttribute('data-af-ready')) return;
      root.setAttribute('data-af-ready', '1');
      var out = root.querySelector('[data-af-cd-time]');
      var span = (Number(root.getAttribute('data-hours')) || 3) * 3600 * 1000;
      var keep = root.getAttribute('data-keep') === 'true';
      var end = Date.now() + span;

      /* Por defecto la promoción se reinicia en cada ingreso (no se guarda nada en el navegador). */
      if (keep) {
        try {
          var saved = Number(window.localStorage.getItem(KEY));
          if (saved > 0) end = saved;
          else window.localStorage.setItem(KEY, String(end));
        } catch (e) {}
      }

      var timer = null;
      function tick() {
        if (!document.body.contains(root)) { clearInterval(timer); return; }
        var s = Math.floor((end - Date.now()) / 1000);
        if (s <= 0) {
          if (keep) { s = 0; clearInterval(timer); }
          else { end = Date.now() + span; s = Math.floor(span / 1000); }
        }
        out.textContent = pad(Math.floor(s / 3600)) + ':' + pad(Math.floor(s % 3600 / 60)) + ':' + pad(s % 60);
      }
      tick();
      timer = setInterval(tick, 1000);
    }

    function initAll() {
      Array.prototype.slice.call(document.querySelectorAll('[data-af-cd]')).forEach(init);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["abrazofit-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

    function initGallery(root) {
      if (root.getAttribute('data-af-ready')) return;
      root.setAttribute('data-af-ready', '1');
      var slides = $$('[data-af-slide]', root);
      var thumbs = $$('[data-af-thumb]', root);
      var seconds = Number(root.getAttribute('data-autoplay')) || 0;
      var col = root.querySelector('[data-af-gal]');
      var cur = 0, timer = null, hold = false;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function show(i) {
        if (!slides.length) return;
        cur = (i + slides.length) % slides.length;
        slides.forEach(function (sl, k) { sl.classList.toggle('is-on', k === cur); });
        thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === cur ? 'true' : 'false'); });
      }
      function start() {
        clearInterval(timer);
        if (reduce || !seconds || slides.length < 2) return;
        timer = setInterval(function () {
          if (!document.body.contains(root)) { clearInterval(timer); return; }
          if (!hold && !document.hidden) show(cur + 1);
        }, seconds * 1000);
      }

      /* Cualquier clic manual reinicia el conteo */
      var prev = root.querySelector('[data-af-prev]');
      var next = root.querySelector('[data-af-next]');
      if (prev) prev.addEventListener('click', function () { show(cur - 1); start(); });
      if (next) next.addEventListener('click', function () { show(cur + 1); start(); });
      thumbs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); start(); }); });

      if (col) {
        col.addEventListener('mouseenter', function () { hold = true; });
        col.addEventListener('mouseleave', function () { hold = false; });
        col.addEventListener('focusin', function () { hold = true; });
        col.addEventListener('focusout', function () { hold = false; });
      }
      show(0);
      start();
    }

    function initAll() { $$('[data-af-hero]').forEach(initGallery); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["abrazofit-toast"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.getAttribute('data-af-ready')) return;
      root.setAttribute('data-af-ready', '1');
      var data;
      try { data = JSON.parse(root.querySelector('[data-af-toast-data]').textContent); } catch (e) { return; }
      if (!data.entries || !data.entries.length) return;
      var title = root.querySelector('[data-af-toast-title]');
      var text = root.querySelector('[data-af-toast-text]');
      var first = (Number(root.getAttribute('data-first')) || 6) * 1000;
      var every = (Number(root.getAttribute('data-interval')) || 35) * 1000;
      var visible = (Number(root.getAttribute('data-visible')) || 5) * 1000;
      var i = 0, hideT = null, loopT = null;

      function say() {
        if (!document.body.contains(root)) { clearInterval(loopT); return; }
        var p = data.entries[i++ % data.entries.length];
        title.textContent = String(data.format || '').replace('{name}', p.name).replace('{city}', p.city);
        text.textContent = data.text + (data.example ? ' ' + data.example : '');
        root.hidden = false;
        clearTimeout(hideT);
        hideT = setTimeout(function () { root.hidden = true; }, visible);
      }
      setTimeout(function () { say(); loopT = setInterval(say, every); }, first);
    }

    function initAll() {
      Array.prototype.slice.call(document.querySelectorAll('[data-af-toast]')).forEach(init);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lc-countdown"] && !Shopify.designMode) return;
  try {
    
(function () {
  function p(n) { return String(n).padStart(2, '0'); }
  function tick() {
    document.querySelectorAll('[data-lc-cd]').forEach(function (el) {
      var t = new Date(el.getAttribute('data-end')).getTime();
      var s = Math.floor((isNaN(t) ? 0 : Math.max(0, t - Date.now())) / 1000);
      el.textContent = Math.floor(s / 86400) + 'd ' + p(Math.floor(s % 86400 / 3600)) + ':' + p(Math.floor(s % 3600 / 60)) + ':' + p(s % 60);
    });
  }
  tick();
  if (!window.__lcCd) { window.__lcCd = setInterval(tick, 1000); }
  document.addEventListener('shopify:section:load', tick);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lc-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.LC) return;
  var LC = (window.LC = { qty: 2 });
  var RELEASIT = ['#rsi_buy_now_button', '.rsi_buy_now_button', '._rsi-buy-now-button', '._rsi-buy-now-button-app-block-hook button', '._rsi-buy-now-button-app-block-hook a', '.rsi-btn-skel'];
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function cop(n) { return '$' + String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }

  function picked() {
    var r = document.querySelector('[data-lc-bundles] input:checked');
    return r ? r.closest('.lc-bd') : null;
  }
  function setVariantOnAllForms(variantId, qty) {
    if (!variantId) return;
    var q = parseInt(qty, 10);
    if (!q || q < 1) q = 1;
    $$('form[action$="/cart/add"] input[name="id"], [data-lc-form] input[name="id"]').forEach(function (i) { i.value = variantId; });
    $$('input[name="product-id"]').forEach(function (i) { i.value = variantId; });
    /* Releasit lee este input al abrir el COD: manda la cantidad real del combo */
    $$('input[name="quantity"]').forEach(function (i) { i.value = String(q); i.setAttribute('value', String(q)); });
    if (window.productData) { window.productData.quantity = q; }
    if (window.productData && Array.isArray(window.productData.variants)) {
      var v = window.productData.variants.find(function (x) { return String(x.id) === String(variantId); });
      if (v) {
        window.productData.selected_or_first_available_variant = v;
        window.productData.selected_variant = v;
        try {
          document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: v } }));
          document.dispatchEvent(new CustomEvent('product:variant-change', { detail: { variant: v } }));
        } catch (e) {}
      }
    }
  }
  function findReleasit() {
    for (var i = 0; i < RELEASIT.length; i++) { var n = document.querySelector(RELEASIT[i]); if (n) return n; }
    return null;
  }
  LC.render = function () {
    var p = picked();
    if (!p) return;
    var q = Number(p.getAttribute('data-qty')) || 1;
    LC.qty = q;
    var total = Number(p.getAttribute('data-total')) / 100;
    $$('[data-lc-total]').forEach(function (el) { el.textContent = q + (q === 1 ? ' unidad' : ' unidades') + ' \u00B7 total ' + cop(total); });
    setVariantOnAllForms(p.getAttribute('data-variant'), q);
  };
  function triggerCOD() {
    LC.render();
    setTimeout(function () {
      var btn = findReleasit();
      if (btn) { btn.click(); return; }
      var attempts = 0;
      var poll = setInterval(function () {
        attempts++;
        var b = findReleasit();
        if (b) { clearInterval(poll); b.click(); return; }
        if (attempts > 30) {
          clearInterval(poll);
          if (window._rsiV2 && typeof window._rsiV2.setState === 'function') { try { window._rsiV2.setState({ isOpen: true }); } catch (e) {} }
        }
      }, 100);
    }, 50);
  }
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.closest && t.closest('[data-lc-bundles]')) LC.render();
  });
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('[data-lc-cta]')) { e.preventDefault(); triggerCOD(); return; }
    var th = t.closest('[data-lc-thumb]');
    if (th) {
      var root = th.closest('[data-lc-hero]');
      var thumbs = $$('[data-lc-thumb]', root);
      var slides = $$('[data-lc-slide]', root);
      var i = thumbs.indexOf(th);
      thumbs.forEach(function (b, j) { b.setAttribute('aria-pressed', j === i ? 'true' : 'false'); });
      slides.forEach(function (s, j) { if (j === i) s.removeAttribute('hidden'); else s.setAttribute('hidden', ''); });
      return;
    }
    var go = t.closest('[data-lc-buy]');
    if (go) {
      var target = document.getElementById('comprar');
      if (target) { e.preventDefault(); target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' }); }
    }
  });
  /* Aviso discreto cada 30 a 45 s, sin cifras */
  function initToast(el) {
    if (el.getAttribute('data-lc-ready')) return;
    el.setAttribute('data-lc-ready', '1');
    var first = (Number(el.getAttribute('data-first')) || 10) * 1000;
    var min = (Number(el.getAttribute('data-min')) || 30) * 1000;
    var max = Math.max(min, (Number(el.getAttribute('data-max')) || 45) * 1000);
    var visible = (Number(el.getAttribute('data-visible')) || 5) * 1000;
    var hideT = null;
    function show() {
      if (!document.body.contains(el)) return;
      el.classList.add('show');
      clearTimeout(hideT);
      hideT = setTimeout(function () { el.classList.remove('show'); }, visible);
      setTimeout(show, min + Math.random() * (max - min));
    }
    setTimeout(show, first);
  }
  LC.init = function () { LC.render(); $$('[data-lc-toast]').forEach(initToast); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', LC.init); else LC.init();
  document.addEventListener('shopify:section:load', LC.init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ma-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initGallery(root) {
      if (root.getAttribute('data-ma-ready')) return;
      root.setAttribute('data-ma-ready', '1');
      var track = root.querySelector('[data-ma-track]');
      var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-ma-thumb]'));
      thumbs.forEach(function (b, i) {
        b.addEventListener('click', function () { track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' }); });
      });
      track.addEventListener('scroll', function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        thumbs.forEach(function (b, j) { b.setAttribute('aria-current', j === i ? 'true' : 'false'); });
      }, { passive: true });
    }
    function initAll() { Array.prototype.slice.call(document.querySelectorAll('[data-ma-hero]')).forEach(initGallery); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nube-rgb-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.NR) return;
  var NR = (window.NR = { qty: 2 });
  var RELEASIT = ['#rsi_buy_now_button', '.rsi_buy_now_button', '._rsi-buy-now-button', '._rsi-buy-now-button-app-block-hook button', '._rsi-buy-now-button-app-block-hook a', '.rsi-btn-skel'];
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function cop(n) { return '$' + String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }

  function picked() {
    var r = document.querySelector('[data-nr-bundles] input:checked');
    return r ? r.closest('.nr-bd') : null;
  }
  function setVariantOnAllForms(variantId, qty) {
    if (!variantId) return;
    var q = parseInt(qty, 10);
    if (!q || q < 1) q = 1;
    $$('form[action$="/cart/add"] input[name="id"], [data-nr-form] input[name="id"]').forEach(function (i) { i.value = variantId; });
    $$('input[name="product-id"]').forEach(function (i) { i.value = variantId; });
    /* Releasit lee este input al abrir el COD: manda la cantidad real del combo */
    $$('input[name="quantity"]').forEach(function (i) { i.value = String(q); i.setAttribute('value', String(q)); });
    if (window.productData) { window.productData.quantity = q; }
    if (window.productData && Array.isArray(window.productData.variants)) {
      var v = window.productData.variants.find(function (x) { return String(x.id) === String(variantId); });
      if (v) {
        window.productData.selected_or_first_available_variant = v;
        window.productData.selected_variant = v;
        try {
          document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: v } }));
          document.dispatchEvent(new CustomEvent('product:variant-change', { detail: { variant: v } }));
        } catch (e) {}
      }
    }
  }
  function findReleasit() {
    for (var i = 0; i < RELEASIT.length; i++) { var n = document.querySelector(RELEASIT[i]); if (n) return n; }
    return null;
  }
  NR.render = function () {
    var p = picked();
    if (!p) return;
    var q = Number(p.getAttribute('data-qty')) || 1;
    NR.qty = q;
    var total = Number(p.getAttribute('data-total')) / 100;
    $$('[data-nr-total]').forEach(function (el) { el.textContent = q + (q === 1 ? ' unidad' : ' unidades') + ' \u00B7 total ' + cop(total); });
    setVariantOnAllForms(p.getAttribute('data-variant'), q);
  };
  function triggerCOD() {
    NR.render();
    setTimeout(function () {
      var btn = findReleasit();
      if (btn) { btn.click(); return; }
      var attempts = 0;
      var poll = setInterval(function () {
        attempts++;
        var b = findReleasit();
        if (b) { clearInterval(poll); b.click(); return; }
        if (attempts > 30) {
          clearInterval(poll);
          if (window._rsiV2 && typeof window._rsiV2.setState === 'function') { try { window._rsiV2.setState({ isOpen: true }); } catch (e) {} }
        }
      }, 100);
    }, 50);
  }
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.closest && t.closest('[data-nr-bundles]')) NR.render();
  });
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('[data-nr-cta]')) { e.preventDefault(); triggerCOD(); return; }
    var th = t.closest('[data-nr-thumb]');
    if (th) {
      var root = th.closest('[data-nr-hero]');
      var thumbs = $$('[data-nr-thumb]', root);
      var slides = $$('[data-nr-slide]', root);
      var i = thumbs.indexOf(th);
      thumbs.forEach(function (b, j) { b.setAttribute('aria-pressed', j === i ? 'true' : 'false'); });
      slides.forEach(function (s, j) { if (j === i) s.removeAttribute('hidden'); else s.setAttribute('hidden', ''); });
      return;
    }
    var go = t.closest('[data-nr-buy]');
    if (go) {
      var target = document.getElementById('comprar');
      if (target) { e.preventDefault(); target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' }); }
    }
  });
  /* Aviso discreto cada 30 a 45 s, sin cifras */
  function initToast(el) {
    if (el.getAttribute('data-nr-ready')) return;
    el.setAttribute('data-nr-ready', '1');
    var first = (Number(el.getAttribute('data-first')) || 10) * 1000;
    var min = (Number(el.getAttribute('data-min')) || 30) * 1000;
    var max = Math.max(min, (Number(el.getAttribute('data-max')) || 45) * 1000);
    var visible = (Number(el.getAttribute('data-visible')) || 5) * 1000;
    var hideT = null;
    function show() {
      if (!document.body.contains(el)) return;
      el.classList.add('show');
      clearTimeout(hideT);
      hideT = setTimeout(function () { el.classList.remove('show'); }, visible);
      setTimeout(show, min + Math.random() * (max - min));
    }
    setTimeout(show, first);
  }
  NR.init = function () { NR.render(); $$('[data-nr-toast]').forEach(initToast); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', NR.init); else NR.init();
  document.addEventListener('shopify:section:load', NR.init);
})();

  } catch(e) { console.error(e); }
})();
})();
